module.exports = __webpack_public_path__ + "static/media/梅菜扣肉.ff01dab4.jpg";